function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122.753 20.4926L123.259 22.1034C123.69 23.4755 123.781 24.9319 123.524 26.3469L122.819 30.2258C122.217 33.5346 118.807 35.5277 115.629 34.4276C112.492 33.3418 109.039 33.6662 106.16 35.3171L76.378 52.3919C75.0349 53.1619 73.3377 52.9013 72.2876 51.7636C69.9443 49.225 66.3889 48.191 63.0496 49.0769L43.8355 54.1746C43.0211 54.3906 42.1822 54.5 41.3397 54.5H25.2879C22.9891 54.5 21.784 51.7703 23.3328 50.0716C27.9148 45.0461 25.1687 36.9422 18.4755 35.7374L10.8456 34.364C7.81958 33.8193 5.51432 31.3458 5.18385 28.2889L3.8635 16.0757C3.09921 9.00603 9.03592 3.02549 16.111 3.73775L56.0417 7.75762C57.3556 7.88989 57.6137 9.69375 56.3897 10.1892C52.0343 11.952 50.4726 17.323 53.2036 21.1464L56.8494 26.2506C61.9756 33.4273 72.7865 32.9685 77.2862 25.3832L82.8413 16.0191C85.2387 11.9777 89.5894 9.5 94.2883 9.5H107.775C114.633 9.5 120.697 13.9506 122.753 20.4926Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgUphill4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 58,
    viewBox: "0 0 127 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUphill4);
export default __webpack_public_path__ + "static/media/uphill4.fbd9a55a.svg";
export { ForwardRef as ReactComponent };